import { render, staticRenderFns } from "./GroupsListFilters.vue?vue&type=template&id=46206a88"
import script from "./GroupsListFilters.vue?vue&type=script&lang=ts"
export * from "./GroupsListFilters.vue?vue&type=script&lang=ts"
import style0 from "./GroupsListFilters.vue?vue&type=style&index=0&id=46206a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports